<template>
	<core-page>
		<common-alerts id="dashboard-alerts" :alerts="alerts" />
		<core-loading v-if="isLoading" />
		<div v-if="!hasSiteError" class="omapi-dash omapi-card__flex">
			<common-welcomebox v-if="!connected" :card-type="connected ? 'dismiss' : 'permanent'" :learn-more="true">
				Instantly grow your email list, get more leads and increase sales with the #1 most powerful conversion
				optimization toolkit in the world.
				<template #afterButtons>
					<core-button
						:href="$urls.docs('getting-started-optinmonster-wordpress-checklist', 'WelcomeBox')"
						class="omapi-create-campaign__link-more"
						target="_blank"
						rel="noopener noreferrer"
						:link-style="true"
						:arrow="true"
					>
						Read the Getting Started Guide
					</core-button>
				</template>
			</common-welcomebox>
			<dashboard-upsell-box
				v-else-if="'none' !== upsellToShow"
				:video-src="upsellVideo"
				:upsell-key="`${upsellToShow}Upsell`"
			>
				<p v-if="showGrowUpsell">
					Onsite Retargeting allows you to trigger campaigns based on your visitor's behaviors...like if
					they're new or returning, or if they've converted a specific campaign already. Upgrade today to save
					50% and gain access to Onsite Retargeting, Coupon Wheels, Geolocation, Live Chat Support and more!
				</p>
				<p v-else>
					Over 70% of the visitors to your website leave without taking any action. You could be stopping them
					with an attention grabbing Exit-Intent® Campaign. Upgrade today to save 50% and unlock Exit-Intent®,
					MonsterLinks™, Yes/No Campaigns, Campaign Scheduling, Device Targeting, Countdown Timers and more!
				</p>
			</dashboard-upsell-box>
			<common-welcome-back-box v-else-if="showWelcomeBack" />
			<dashboard-stats-widget />
			<div class="omapi-dash__cards-wrapper omapi-dash__cards-wrapper__left">
				<dashboard-template-select-widget />
				<dashboard-top-campaigns-widget />
			</div>
			<div class="omapi-dash__cards-wrapper omapi-dash__cards-wrapper__right">
				<dashboard-upsell-widget
					v-if="connected && (showProUpsell || showGrowUpsell)"
					:upsell-plan="upsellToShow"
				/>
				<dashboard-announcements-widget
					v-if="announcements.length || announcementsLoading"
					:is-loading="announcementsLoading"
					:upsell-to-show="upsellToShow"
					:announcements="announcements"
				/>
				<dashboard-resources-widget />
			</div>
		</div>
		<dashboard-resources-widget v-else />
	</core-page>
</template>

<script>
import { bulkWatchHandler } from '@/utils';
import { mapState, mapGetters } from 'vuex';

export default {
	data() {
		return {
			canShowWelcomeBack: true,
		};
	},
	computed: {
		...mapState(['alerts']),
		...mapState('dashboard', ['dismissedWelcomeBack', 'dismissedProUpsell', 'dismissedGrowthUpsell']),
		...mapGetters(['connected', 'hasSiteError', 'upgradeGrowth', 'topTier']),
		...mapGetters('dashboard', ['announcements']),
		isLoading() {
			return this.$store.getters.isLoading('plugins');
		},
		announcementsLoading() {
			return this.$store.getters.isLoading('announcements');
		},
		canShowUpsell() {
			return !this.topTier && 2 < this.visits;
		},
		showGrowUpsell() {
			return this.canShowUpsell && this.upgradeGrowth && !this.dismissedGrowthUpsell;
		},
		showProUpsell() {
			return this.canShowUpsell && !this.upgradeGrowth && !this.dismissedProUpsell;
		},
		showWelcomeBack() {
			return this.canShowWelcomeBack && !this.dismissedWelcomeBack;
		},
		upsellVideo() {
			const videoId = this.showGrowUpsell ? 'z7nYlJPRePc' : 'BBXLrYD3-hs';
			return `https://www.youtube.com/embed/${videoId}?rel=0&controls=0&showinfo=0&autoplay=1`;
		},
		visits() {
			return this.$get('$store.state.visits.' + (this.$route.fullPath || this.$route.path), 1);
		},
		upsellToShow() {
			if (this.showGrowUpsell) {
				return 'Growth';
			}
			if (this.showProUpsell) {
				return 'Pro';
			}
			return 'none';
		},
	},
	watch: bulkWatchHandler(['dismissedProUpsell', 'dismissedGrowthUpsell'], 'disableShowWelcomeBack'),
	beforeCreate() {
		this.$store.dispatch('dashboard/fetch');
		this.$store.dispatch('dashboard/fetchAnnouncements');
	},
	methods: {
		disableShowWelcomeBack(dismissed) {
			if (dismissed) {
				this.canShowWelcomeBack = false;
			}
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/variables';
@import '../assets/scss/pages/dashboard';
</style>
